import React from 'react';
import PropTypes from 'prop-types';
import { hasMultipleActiveOptions } from './Filtering/filterHelpers';

const HeaderTitle = (props) => {
  const filterBrand = props && props.filterBrand && props.filterBrand.shift();
  const filterType = props && props.filterType && props.filterType.shift();
  const filterBrandActiveOption = filterBrand && filterBrand.options
    .find((itemOption) => itemOption.active);
  const filterTypeActiveOption = filterType && filterType.options
    .find((itemOption) => itemOption.active);
  let pageTitle = props.segment;

  if (hasMultipleActiveOptions(filterBrand) || hasMultipleActiveOptions(filterType)) {
    if (filterBrandActiveOption && hasMultipleActiveOptions(filterType)) {
      pageTitle = `${filterBrandActiveOption.label} ${props.segment}`;
    } if (filterTypeActiveOption && hasMultipleActiveOptions(filterBrand)) {
      pageTitle = filterTypeActiveOption.label;
    } if (hasMultipleActiveOptions(filterBrand) && hasMultipleActiveOptions(filterType)) {
      pageTitle = props.segment;
    }
  } else {
    if (filterTypeActiveOption) {
      pageTitle = filterTypeActiveOption.label;
    } if (filterBrandActiveOption) {
      pageTitle = `${filterBrandActiveOption.label} ${props.segment}`;
    } if (filterTypeActiveOption && filterBrandActiveOption) {
      pageTitle = `${filterBrandActiveOption.label} ${filterTypeActiveOption.label}`;
    }
  }

  return (
    <h1 className={'pageTitle'}>{pageTitle}</h1>
  );
};

HeaderTitle.displayName = 'HeaderTitle';

HeaderTitle.propTypes = {
  filterBrand: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  filterType: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  segment: PropTypes.string.isRequired
};

export default HeaderTitle;
